'use client';
const posts = [
{
  title: 'COSA : Une Franchise Médicale Innovante en Côte d\'Ivoire',
  date: 'Septembre 2025',
  author: 'Équipe COSA',
  text: 'Le projet COSA incarne les nouvelles ambitions de Concept Labo et symbolise une vision renouvelée : développer une franchise médicale pour offrir des services médicaux et biomédicaux de pointe, accessibles et de haute qualité, à travers toute l\'Afrique.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1168b0e7c-1772412145587.png",
  alt: 'Médecin africain examinant des dossiers médicaux et des documents de recherche dans une clinique moderne'
},
{
  title: 'Le Groupe Cofina Rejoint Concept Labo pour Transformer la Santé',
  date: 'Septembre 2025',
  author: 'Direction COSA',
  text: 'En 2023, l\'arrivée du Groupe Cofina, acteur majeur de l\'innovation et de la mésofinance, a marqué une étape cruciale dans le développement de l\'activité biomédicale, visant à créer un écosystème de services médicaux accessibles à tous.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1804c3c05-1772824481981.png",
  alt: 'Infirmière africaine tenant la main d\'un patient dans une salle d\'hôpital chaleureuse montrant des soins compassionnels'
},
{
  title: 'Notre Branding : Les Couleurs et Valeurs de COSA',
  date: 'Septembre 2025',
  author: 'Équipe Communication',
  text: 'Le logo COSA traduit à la fois l\'identité et les valeurs de l\'organisation. Le vert incarne la santé et la croissance, tandis que l\'orange doré exprime la chaleur humaine, l\'énergie et la solidarité panafricaine.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_114e1655f-1772499294308.png",
  alt: 'Médecin africaine en blouse blanche souriant et consultant des informations patient sur une tablette'
}];


export default function BlogSection() {
  return (
    <section id="blog-1" className="wide-60">
      <div className="max-w-7xl mx-auto px-4">
        {/* TITLE */}
        <div className="text-center mb-12">
          <h3 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
            Actualités & Informations COSA
          </h3>
          <p className="text-gray-500 max-w-xl mx-auto">
            Suivez les dernières actualités de la Compagnie de Santé Africaine et restez informé de nos avancées dans le domaine de la santé en Côte d'Ivoire.
          </p>
        </div>

        {/* POSTS GRID */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts?.map((post, i) =>
          <div
            key={i}
            className="bg-white rounded-xl overflow-hidden shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
            
              {/* Image */}
              <div className="overflow-hidden">
                <img
                src={post?.img}
                alt={post?.alt}
                className="w-full object-cover transition-transform duration-400 hover:scale-105"
                style={{ height: '220px' }} />
              </div>

              {/* Content */}
              <div className="p-6">
                <h5 className="font-bold text-base mb-2">
                  <a
                  href="#"
                  className="transition-colors"
                  style={{ color: '#1d3c5e' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#0e5932'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#1d3c5e'}>
                    {post?.title}
                  </a>
                </h5>
                <span className="text-xs text-gray-400 block mb-3">
                  {post?.date} par{' '}
                  <span style={{ color: '#0e5932' }}>{post?.author}</span>
                </span>
                <p className="text-sm text-gray-600 leading-relaxed">{post?.text}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);
}